import https from 'hub-http/clients/apiClient';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
const getWebsiteFlowsKey = () => 'WebsiteFlows';
const BASE_URL = '/content-workflows/v1';
const _fetchWebsiteFlows = guid => https.get(`${BASE_URL}/followup-email/pages-by-form/${guid}`);
const getWebsiteFlows = guid => getFromEarlyRequest(getWebsiteFlowsKey(), () => _fetchWebsiteFlows(guid));
export default getWebsiteFlows;